import { render, staticRenderFns } from "./PerformanceReport.vue?vue&type=template&id=32782c2b&scoped=true&"
import script from "./PerformanceReport.vue?vue&type=script&lang=js&"
export * from "./PerformanceReport.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReport.vue?vue&type=style&index=0&id=32782c2b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32782c2b",
  null
  
)

export default component.exports